document.querySelectorAll('.ModalMapMetro').forEach((modalEl) => {
    const elBody = modalEl.querySelector('.ModalMapMetro__body');
    const elBodySvg = elBody.querySelector('.ModalMapMetro__svg');
    const elSelected = modalEl.querySelector('.ModalMapMetro__selected');
    const elCount = modalEl.querySelector('.ModalMapMetro__count');
    const elZoomIn = modalEl.querySelector('.ModalMapMetro__zoomIn');
    const elZoomOut = modalEl.querySelector('.ModalMapMetro__zoomOut');
    const elReset = modalEl.querySelector('.modal__reset');
    const elSelectedAll = modalEl.querySelector('.ModalMapMetro__selected-all');
    const modalSearch = modalEl.querySelector('.modal__search .SearchableInput');
    const inputName = 'metro';

    elSelectedAll.addEventListener('click', () => {
        elSelected.classList.toggle('ModalMapMetro__selected--show');
    });

    modalEl.addEventListener('open', () => {
        if (modalEl.classList.contains('ready')) return;
        modalEl.classList.add('ready');

        fetch('/img/map-metro.txt')
            .then((response) => response.text())
            .then((mapSvg) => {
                elBodySvg.innerHTML = mapSvg;

                const map = new MoscowMetro(elBodySvg, {
                    zoom: {
                        startScale: 2,
                        minScale: 0.9,
                        maxScale: 10,
                        step: window.$isMobile ? 1 : 0.3,
                    },
                    middleware: ({ id: stationNameId, name, line, select }) => {
                        const id = getIdMap(stationNameId);
                        if (select) {
                            const input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = inputName;
                            input.value = id;
                            const tag = document.createElement('div');
                            tag.className = 'tag tag--bordered tag--close tag--md';
                            tag.setAttribute('data-id', id);
                            tag.setAttribute('data-line', line);
                            tag.innerHTML = name || id;
                            tag.append(input);
                            elSelected.append(tag);
                            tag.addEventListener('click', remove);
                            input.addEventListener('reset', remove);

                            if(id) {
                                window.filtersMainAddFilter(inputName, id, tag.innerHTML.trim());
                            }
                            else {
                                console.error('Metro not id', stationNameId, name, line);
                            }

                            function remove() {
                                map.deselect(stationNameId);
                                tag.remove();
                                window.filtersMainRemoveFilter(inputName, id);
                                recalcCount();
                            }
                        } else {
                            removeId(stationNameId);
                        }
                        recalcCount();
                    },
                });


                function recalcCount() {
                    if(elCount) {
                        const count = map.state.selected.length;
                        elCount.innerHTML = count ? ` (${count})` : '';
                    }
                }

                elZoomIn.addEventListener('click', map.panzoom.zoomIn);
                elZoomOut.addEventListener('click', map.panzoom.zoomOut);
                elReset.addEventListener('click', () => {
                    map.state.selected.forEach(removeId);
                    map.deselect(map.state.selected);
                    modalSearch.querySelector('input').value = '';
                });
                console.log({modalSearch});
                modalSearch.addEventListener('select', ({detail: inputEl}) => {
                    const value = metroMapNames[inputEl.dataset.value];
                    console.log(value, inputEl.dataset.value);
                    map.selectOne(value, true);
                });
                const {metro: metroSelectCookie = []} = getCookieFilters();
                if(metroSelectCookie) {
                    const ids = metroSelectCookie.map((id) => metroMapNames[id]).filter((item) => item);
                    map.select(ids, true);
                }

                window.metroMap = map;
            });
    });

    function removeId(stationNameId) {
        const id = getIdMap(stationNameId);
        elSelected.querySelector(`.tag[data-id="${id}"]`).remove();
        window.filtersMainRemoveFilter(inputName, id);
    }
});

function getIdMap(name) {
    return metroMapStations[name.toLowerCase()];
}

const metroMapStations = {
    "коммунарка": "388",
    "ольховая": "436",
    "прокшино": "450",
    "филатов луг": "451",
    "саларьево": "403",
    "румянцево": "89",
    "тропарево": "88",
    "воробьевы горы": "252",
    "университет": "272",
    "юго-западная": "90",
    "фрунзенская": "53",
    "спортивная": "273",
    "проспект вернадского": "290",
    "библиотека им.ленина": "72",
    "кропоткинская": "63",
    "охотный ряд": "256",
    "чистые пруды": "6",
    "красные ворота": "22",
    "преображенская площадь": "198",
    "черкизовская": "331",
    "одинцово": "854",
    "баковка": "104",
    "сколково": "103",
    "рабочий поселок": "204",
    "немчиновка": "105",
    "сетунь": "205",
    "лобня": "833",
    "шереметьевская": "834",
    "бескудниково": "164",
    "дегунино": "210",
    "хлебниково": "454",
    "водники": "402",
    "новодачная": "367",
    "марк": "397",
    "долгопрудная": "368",
    "аэропорт внуково": "470",
    "пыхтино": "472",
    "рассказовка": "393",
    "новопеределкино": "313",
    "говорово": "305",
    "ломоносовский проспект": "126",
    "минская": "335",
    "раменки": "125",
    "солнцево": "312",
    "боровское шоссе": "390",
    "озерная": "358",
    "народное ополчение": "128",
    "мневники": "127",
    "терехово": "266",
    "петровский парк": "2",
    "варшавская": "119",
    "каховская": "201",
    "зюзино": "12",
    "воронцовская": "152",
    "новаторская": "151",
    "мичуринский проспект": "360",
    "нагатинский затон": "303",
    "кленовый бульвар": "221",
    "нижегородская": "131",
    "хорошевская": "208",
    "шелепиха": "94",
    "лефортово": "309",
    "физтех": "366",
    "достоевская": "59",
    "фонвизинская": "381",
    "бутырская": "177",
    "дубровка": "189",
    "римская": "171",
    "сретенский бульвар": "66",
    "крестьянская застава": "27",
    "трубная": "60",
    "марьина роща": "220",
    "яхромская": "183",
    "селигерская": "181",
    "лианозово": "329",
    "верхние лихоборы": "37",
    "кожуховская": "365",
    "печатники": "339",
    "волжская": "202",
    "люблино": "193",
    "братиславская": "91",
    "марьино": "92",
    "борисово": "359",
    "шипиловская": "25",
    "зябликово": "24",
    "аминьевская": "147",
    "апрелевка": "981",
    "победа": "468",
    "лесной городок": "476",
    "внуково": "480",
    "крекшино": "466",
    "переделкино": "391",
    "солнечная": "307",
    "мещерская": "306",
    "матвеевская": "124",
    "поклонная": "304",
    "очаково": "370",
    "мичуринец": "394",
    "толстопальцево": "786",
    "серп и молот": "169",
    "чухлинка": "107",
    "кокошкино": "486",
    "санино": "465",
    "кусково": "328",
    "реутов": "40",
    "никольское": "295",
    "салтыковская": "852",
    "кучино": "851",
    "железнодорожная": "861",
    "ольгино": "864",
    "балтийская": "69",
    "коптево": "100",
    "лихоборы": "38",
    "окружная": "39",
    "ростокино": "284",
    "локомотив": "311",
    "угрешская": "187",
    "зил": "29",
    "крымская": "123",
    "лужники": "274",
    "верхние котлы": "102",
    "белокаменная": "259",
    "измайлово": "243",
    "соколиная гора": "79",
    "хорошево": "129",
    "зорге": "122",
    "панфиловская": "36",
    "площадь гагарина": "155",
    "стрешнево": "49",
    "нахабино": "784",
    "аникеевка": "789",
    "опалиха": "790",
    "павшино": "355",
    "пенягино": "356",
    "депо": "310",
    "перерва": "299",
    "курьяново": "271",
    "москворечье": "269",
    "покровское": "275",
    "красный строитель": "318",
    "бутово": "401",
    "щербинка": "398",
    "остафьево": "399",
    "силикатная": "400",
    "подольск": "829",
    "москва-товарная": "217",
    "калитники": "286",
    "трикотажная": "137",
    "красный балтиец": "74",
    "гражданская": "14",
    "красногорская": "357",
    "сходня": "385",
    "подрезково": "383",
    "молжаниново": "395",
    "химки": "396",
    "левобережная": "317",
    "ховрино": "315",
    "грачевская": "293",
    "перово": "108",
    "ухтомская": "325",
    "панки": "346",
    "томилино": "347",
    "красково": "430",
    "малаховка": "431",
    "удельная": "676",
    "быково": "799",
    "люберцы": "327",
    "ильинская": "797",
    "отдых": "798",
    "кратово": "811",
    "есенинская": "809",
    "фабричная": "810",
    "раменское": "863",
    "ипподром": "911",
    "вешняки": "186",
    "косино": "279",
    "андроновка": "251",
    "останкино": "178",
    "моссельмаш": "182",
    "новоподрезково": "384",
    "новослободская": "58",
    "добрынинская": "46",
    "краснопресненская": "23",
    "парк культуры": "51",
    "павелецкая": "9",
    "проспект мира": "148",
    "алтуфьево": "165",
    "бибирево": "163",
    "владыкино": "111",
    "петровско-разумовская": "253",
    "отрадное": "110",
    "тимирязевская": "319",
    "дмитровская": "143",
    "менделеевская": "57",
    "савеловская": "140",
    "цветной бульвар": "61",
    "чеховская": "156",
    "боровицкая": "71",
    "полянка": "75",
    "серпуховская": "47",
    "тульская": "106",
    "нагатинская": "54",
    "нагорная": "55",
    "нахимовский проспект": "56",
    "чертановская": "118",
    "южная": "117",
    "пражская": "241",
    "улица академика янгеля": "341",
    "бульвар дмитрия донского": "379",
    "севастопольская": "200",
    "бунинская аллея": "387",
    "улица горчакова": "234",
    "улица скобелевская": "233",
    "лесопарковая": "375",
    "битцевский парк": "350",
    "улица старокачаловская": "376",
    "бульвар адмирала ушакова": "232",
    "октябрьская": "48",
    "новоясеневская": "349",
    "ясенево": "300",
    "теплый стан": "301",
    "коньково": "302",
    "новые черемушки": "11",
    "беляево": "162",
    "калужская": "153",
    "профсоюзная": "1",
    "ленинский проспект": "154",
    "академическая": "113",
    "шаболовская": "175",
    "третьяковская": "76",
    "тургеневская": "67",
    "сухаревская": "62",
    "рижская": "133",
    "алексеевская": "132",
    "вднх": "333",
    "ботанический сад": "145",
    "свиблово": "87",
    "бабушкинская": "85",
    "медведково": "86",
    "марксистская": "34",
    "авиамоторная": "215",
    "новогиреево": "41",
    "шоссе энтузиастов": "77",
    "площадь ильича": "170",
    "новокосино": "294",
    "александровский сад": "73",
    "смоленская": "4",
    "студенческая": "353",
    "арбатская": "64",
    "фили": "96",
    "филевский парк": "377",
    "багратионовская": "136",
    "пионерская": "238",
    "кутузовская": "114",
    "деловой центр": "212",
    "курская": "21",
    "киевская": "18",
    "пятницкое шоссе": "296",
    "митино": "297",
    "волоколамская": "138",
    "мякинино": "262",
    "строгино": "192",
    "крылатское": "190",
    "молодежная": "191",
    "семеновская": "242",
    "парк победы": "267",
    "славянский бульвар": "240",
    "кунцевская": "206",
    "измайловская": "167",
    "первомайская": "166",
    "щелковская": "168",
    "электрозаводская": "30",
    "партизанская": "289",
    "площадь революции": "43",
    "планерная": "230",
    "сходненская": "229",
    "кузьминки": "244",
    "выхино": "264",
    "лермонтовский проспект": "280",
    "жулебино": "352",
    "котельники": "194",
    "рязанский проспект": "185",
    "текстильщики": "130",
    "пролетарская": "314",
    "таганская": "33",
    "пушкинская": "157",
    "тушинская": "231",
    "октябрьское поле": "121",
    "полежаевская": "246",
    "улица 1905 года": "82",
    "волгоградский проспект": "188",
    "кузнецкий мост": "45",
    "беговая": "207",
    "спартак": "237",
    "щукинская": "372",
    "китай-город": "160",
    "беломорская": "176",
    "речной вокзал": "70",
    "сокол": "15",
    "аэропорт": "3",
    "динамо": "13",
    "белорусская": "5",
    "маяковская": "197",
    "театральная": "257",
    "технопарк": "222",
    "коломенская": "101",
    "каширская": "159",
    "орехово": "283",
    "домодедовская": "282",
    "красногвардейская": "8",
    "алма-атинская": "93",
    "кантемировская": "270",
    "царицыно": "288",
    "тверская": "158",
    "войковская": "172",
    "водный стадион": "68",
    "новокузнецкая": "83",
    "автозаводская": "10",
    "окская": "184",
    "стахановская": "109",
    "юго-восточная": "263",
    "лухмановская": "324",
    "некрасовка": "326",
    "сокольники": "218",
    "комсомольская": "80",
    "красносельская": "180",

    "бульвар рокоссовского": "260",
    "тестовская": "276",
    "цска": "16",
    "площадь трёх вокзалов": "227",
    "зеленоград — крюково": "835",
    "фирсановская": "971",
    "плющево": "150",
    "баррикадная": "7",
    "улица дмитриевского": "323",
};

const metroMapNames = Object.keys(metroMapStations).reduce((tmp, key) => {
    tmp[metroMapStations[key]] = key;
    return tmp;
}, {})
